import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteObserver: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(
      () => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }),
      200
    );
  }, [pathname]);

  return <></>;
};

export default RouteObserver;
